<template>
  <div class="vouchersredemptionlist">
    <div class="vouchersredemptionlist__header">
      <div class="vouchersredemptionlist__header__left">
        <i class="adx-ic_search"></i>
        <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
      </div>
      <div class="vouchersredemptionlist__header__right">
        <p>Sort by :</p>
        <div>
          <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="vouchersredemptionlist__listing">
      <template v-if="!isEmpty && !isLoading">
        <adx-vouchers-redemption-list :items='items' />
        <adx-pagination
          v-if="items.length > 0"
          @change-page="selectPage"
          :max-page="maxPage"
          :selected-page="selectedPage"
        />
      </template>
      <adx-empty-selection v-if="isEmpty && !isLoading" />
      <adx-loading v-if="isLoading" slot="loading" />
    </div>
  </div>
</template>

<script>
import ListVouchers from '@/views/Admin/Vouchers/VouchersRedemptionList/ListItems'
import DropdownSort from '@/components/Form/SelectDropdown'
import Pagination from '@/components/Pagination'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import moment from 'moment'
import lib from '@/lib/util'
import { helpers } from '@/lib/validation/'

export default {
  name: 'adx-admin-vouchers-redemption-list',
  components: {
    'adx-vouchers-redemption-list': ListVouchers,
    'adx-dropdown-sort': DropdownSort,
    'adx-pagination': Pagination,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
  },
  props: {

  },
  data() {
    return {
      items: [],
      sort: [
        {
          'id': 0,
          'label': 'Last Added',
          'value': '-date'
        },
        {
          'id': 1,
          'label': 'First Added',
          'value': 'date'
        },
      ],
      searchBoxValue: '',
      selectedSortValue: '-date',
      selectedPage: 1,
      maxPage: 1,
      isLoading: false,
      isLoading: false,
      isEmpty: false
    }
  },
  computed: {

  },
  watch: {
    selectedSortValue(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedPage = 1
        this.getHistory()
      }
    },
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.selectedPage = 1
        this.getHistory()
      })
    }, 500),
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.getHistory()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getHistory() {
      (async () => {
        this.items = []
        this.isLoading = true
        let param = { 
          page: this.selectedPage,
          ordering: this.selectedSortValue
        }
        if (this.searchBoxValue) param.search = this.searchBoxValue
        const { data } = await api.get(apiV2.adminVoucherHistory, { needToken: true, params: param })
        if (data.count == 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
          this.maxPage = data.max_page
          data.results.map(item => {
            this.items.push({
              fullname: item.user.full_name,
              email: item.user.email,
              date: item.date,
              code: item.voucher.code,
              price: item.voucher.nominal
            })
          })
        }
        this.isLoading = false
      })();
    },
    selectPage(page) {
      this.selectedPage = page
      this.getHistory()
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>